import Axios from '../lib/axios'
import store from '@/store'

class SeizureService {
  async patientSeizures (patientId) {
      const result = await Axios.authenticated().get(`/seizures/${patientId}`, {})
      return result
  }

  async search (filters) {
    const result = await Axios.authenticated().get(`/seizures/search`, { params: filters })
    return result
  }

  async drugSearch (filters) {
    const result = await Axios.authenticated().get(`/seizures/drug-search`, { params: filters })
    return result
  }

  async create (seizure) {
    let newSeizure = JSON.parse(seizure.get('seizure'))
    let config = {
      onUploadProgress: e => store.state.currentProgress = Math.round(e.loaded * 100 / e.total),
      headers: {
        path: newSeizure.patientId
      }
    }
    const result = await Axios.authenticated().post(
      `/seizures/${newSeizure.patientId}`,
      seizure,
      config
    )
    return result
  }

  async show (id) {
    const result = await Axios.authenticated().get(`/seizures/${id}/show`, {})
    return result
  }

  async update (seizure) {
    let editedSeizure = JSON.parse(seizure.get('seizure'))
    let config = {
      onUploadProgress: e => store.state.currentProgress = Math.round(e.loaded * 100 / e.total),
      headers: {
        path: editedSeizure.patientId
      }
    }
    const result = await Axios.authenticated().put(
      `/seizures/${editedSeizure.patientId}`,
      seizure, 
      config
    )
    return result
  }

  async deleteImage (patientId, id, img) {
    const result = await Axios.authenticated().put(`/seizures/${patientId}/${id}`, {
      'id': id,
      'imageToDelete': img.index,
      'imageToDeleteKey':  img.img.key
    })
    return result
  }

  async delete (seizure) {
    const result = await Axios.authenticated().delete(`/seizures/${seizure.patientId}`, { data: seizure })
    return result
  }

}

export default new SeizureService()
